import { SVGProps } from 'react';
import { ReactComponent } from 'icons/phone.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const PhoneIcon = (props: Props) => {
  return <ReactComponent className="merc-icon-phone" {...props} />;
};
